/**
 * Depth layer — the heavy /recon/master payload, indexed for O(1) row lookup.
 * Pure module (no API imports) so the merge logic is unit-testable.
 */
import type { CockpitSummary, InvoiceRecord } from '../cashflow/types';

export interface Depth {
	/** invoice_number → full master record (zoho dates, comms, kam, labels, follow_up). */
	by: Map<string, InvoiceRecord>;
	/** master summary (exec_brief feeds aging ribbon, top exposure, deep-review strip). */
	summary: CockpitSummary | null;
}

export const buildDepth = (invoices: InvoiceRecord[], summary?: CockpitSummary | null): Depth => ({
	by: new Map(invoices.map(r => [r.num, r])),
	summary: summary ?? null,
});
